import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { setSessionItem } from '../../../webStorage/sessionStorage';
import Button from '../../common/buttons/Button';
import {
  ONBOARDING_SCREEN_BTN_ENUMS,
  startOrderingTrack,
} from '../../../analytics/tracker/events/menuEvents';
import { getUserId } from '../../../webStorage/localStorage';
import { useSelector } from 'react-redux';
import LazyImage from '../../common/lazyLoad';
const BottomStaticFields = ({ images, showMenuHandler }) => {
  const { t } = useTranslation();
  const restarantSettingFromRedux = useSelector((state) => state.restSetting?.Setting);

  const trackObj = {
    User_ID: getUserId(),
    Restaurant_ID: restarantSettingFromRedux?.id,
    Restaurant_Name: restarantSettingFromRedux?.name,
  };

  const { name } = useParams();
  const clickHander = (btnType) => {
    startOrderingTrack(btnType, trackObj);
    showMenuHandler();
    setSessionItem(name, true);
  };
  return (
    <>
      <div className='d-flex flex-column justify-content-around gap-4'>
        <div className=' d-flex flex-column text-center'>
          <div className='appSubHeader fs-18 fw-600'>{t('how_to_order')}</div>
          <div className='fs-16 fw-400'>{t('ordering_food_has')}</div>
        </div>
        <div className='d-flex justify-content-around w-100 align-items-start'>
          {images.map((item, index) => (
            <div
              className='d-flex flex-column justify-content-center promotionFooter align-items-center gap-1 text-align-center flex-1'
              key={index}
              onClick={() => clickHander(ONBOARDING_SCREEN_BTN_ENUMS[index + 1])}>
              <LazyImage className='promotionsIcon' src={item.src} alt={item.text} />
              <div className='fw-600'>{item.text}</div>
            </div>
          ))}
        </div>
        <div className='row m-0 fw-600 d-flex justify-content-center'>
          <Button
            text={t('start_ordering')}
            type='btn-large ml-0'
            onClick={() => clickHander(ONBOARDING_SCREEN_BTN_ENUMS.START_ORDERING)}
          />
        </div>
      </div>
    </>
  );
};

export default BottomStaticFields;
